import Toast from 'toastr';
import 'toastr/build/toastr.min.css';
export default Toast;

  